export default ['ES', 'FR', 'PT', 'IT', 'AD'];
